import type { Ordre } from "types/ordre";

const BRAND_LABEL: Record<string, { name: string; site: string }> = {
  AP: { name: "Peugeot", site: "PEUGEOT HERIC AUTOMOBILES" },
  AC: { name: "Citroën", site: "CITROEN HERIC AUTOMOBILES" },
  DS: { name: "DS", site: "DS" },
  OP: { name: "Opel", site: "OPEL HERIC AUTOMOBILES" },
  OV: { name: "Opel", site: "OPEL HERIC AUTOMOBILES" },
  OPEL: { name: "Opel", site: "OPEL HERIC AUTOMOBILES" },
};

/**
 * Alerte « Rendez-vous Internet » : le client a réservé lui-même sur le site du
 * constructeur (Peugeot / Citroën / Opel), pas dans Carvis. ServiceBox garde la demande
 * à moitié faite — créneau de dépôt seulement : ni restitution, ni équipe, ni dossier —
 * tant que l'accueil ne l'a pas complétée. Sans dossier, pas d'OR le jour J (et le
 * planning ServiceBox de ce jour-là peut planter). Disparaît une fois traitée (synchro).
 */
export default function InternetRdvBanner({ ordre, className = "" }: {
  ordre: Pick<Ordre, "sb_internet_rdv" | "sb_internet_pending" | "sb_internet_brand">;
  className?: string;
}) {
  if (!ordre.sb_internet_rdv) return null;
  const brand = BRAND_LABEL[(ordre.sb_internet_brand || "").toUpperCase()];
  const siteName = brand ? `site ${brand.name}` : "site du constructeur";

  if (!ordre.sb_internet_pending) {
    return (
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-h4 font-semibold ${className}`}
        style={{ background: "#F5F3FF", border: "1px solid #DDD6FE", color: "#5B21B6", whiteSpace: "nowrap" }}
        title={`Rendez-vous pris par le client sur le ${siteName}, traité dans ServiceBox`}
      >
        RDV Internet · {brand?.name || "constructeur"}
      </span>
    );
  }

  return (
    <div
      className={`flex flex-row gap-3 rounded-lg px-3 py-2.5 ${className}`}
      style={{ background: "#FEF2F2", border: "2px solid #DC2626" }}
      role="alert"
    >
      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="#DC2626" strokeWidth={2.2}
        strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 1 }}>
        <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
        <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <div className="flex flex-col gap-1 min-w-0" style={{ fontFamily: "Poppins" }}>
        <span className="text-h3 font-bold" style={{ color: "#991B1B" }}>
          RDV Internet à compléter — pris par le client sur le {siteName}
        </span>
        <span className="text-h4" style={{ color: "#7F1D1D" }}>
          Ce rendez-vous ne vient pas de Carvis : le client l'a réservé lui-même en ligne.
          ServiceBox ne l'a enregistré qu'à moitié (créneau de dépôt seulement) : <b>pas de restitution,
          pas d'équipe, pas de dossier</b>. Tant que ce n'est pas complété, impossible de récupérer
          l'OR, et le planning ServiceBox de ce jour-là peut refuser de s'afficher.
        </span>
        <span className="text-h4 font-semibold" style={{ color: "#7F1D1D" }}>
          À faire ici : renseignez la date et l'heure de restitution, puis « Enregistrer ». Carvis
          complète le RDV dans ServiceBox (restitution, équipe mécanique) et le dossier est créé :
          l'OR pourra sortir.
        </span>
      </div>
    </div>
  );
}
